module.exports = __webpack_public_path__ + "static/media/icon-schematic.1e55e939.svg";